/**
 * Fetch the HTML for a SVG icon
 * @param absolutePath Path like `"/assets/icons/banana.svg"`
 * @returns The SVG HTML
 */
export const fetchIcon = async (absolutePath: string) => {
  const body = await fetch(absolutePath).then((r) => r.text());
  return body;
};

export const aBasisIcon = () => {
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll('[is="basis-icon"')
  );

  components.forEach(async (component) => {
    const fileName = component.dataset.icon;
    if (!fileName) {
      component.remove();
      console.error('Missing [data-icon] on', component);
      return;
    }

    const fullPath = `/assets/icons/${fileName}`;

    const style = document.createElement('style');
    if (component.classList.contains('cover')) {
      style.textContent = `
      svg {
        position: absolute;
        width: 100%;
        height: ${component.classList.contains('stretch') ? '100%' : 'auto'};
        left: 0;
        top: 0;
        object-fit: cover;
      }
      `;
    } else {
      style.textContent = `
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
      svg {
        width: 100%;
        height: 100%;
      }
      `;
    }

    const svgContainer = document.createElement('span');

    const svg = await fetchIcon(fullPath);
    svgContainer.innerHTML = svg;

    const svgElement = svgContainer.querySelector('svg');

    if (component.classList.contains('stretch')) {
      svgElement.setAttribute('preserveAspectRatio', 'none');
    }

    const shadow = component.attachShadow({
      mode: 'open'
    });
    shadow.append(svgContainer);
    shadow.appendChild(style);
    component.classList.add('loaded');
  });
};
